var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRgateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,0H3C1.3,0,0,1.3,0,3v10c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V3C16,1.3,14.7,0,13,0z M9.4,11.9 c-0.2,0.1-1.2,0.2-1.8-0.5c-0.3-0.4-0.9-1.2-1.5-2.3c-0.3,0-0.5,0-0.8,0v1.7c0,0.8,0.2,0.8,0.9,0.9v0.3c-0.2,0-0.8,0-1.3,0 c-0.5,0-0.9,0-1.2,0v-0.3c0.6-0.1,0.8,0,0.8-0.9V6.9c0-0.8-0.2-0.8-0.8-0.9V5.8c0.9,0,1.9,0,2.5,0c1.1,0,2,0.5,2,1.6 c0,0.8-0.6,1.5-1.4,1.7c0.5,0.9,1.1,1.6,1.5,2.1c0.3,0.3,0.6,0.5,1,0.5V11.9z M10.2,7.1C9.3,7.1,9,6.6,9,6V4.8 c0-0.4,0.3-1.1,1.2-1.1c0.9,0,1.1,0.6,1.1,0.6L11,4.6c0,0-0.2-0.4-0.7-0.4c-0.3,0-0.7,0.3-0.7,0.7v1c0,0.5,0.2,0.8,0.6,0.8 c0.5,0,0.8-0.4,0.8-1h-0.6V5.3h1.1C11.4,6.1,11.6,7.1,10.2,7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4,7.4c0-0.8-0.5-1.2-1.3-1.2c-0.3,0-0.6,0-0.8,0v2.5c0.2,0,0.4,0,0.7,0C6.9,8.7,7.4,8.2,7.4,7.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgateLogo);
export default __webpack_public_path__ + "static/media/rgate-logo.7497091c.svg";
export { ForwardRef as ReactComponent };